/* eslint-disable */ import { EnumReflection } from '@salsita-ai/platform-project-sdk/domain';
export const ApplicationVersion = '0.0.0';
export const PublishedData = {
    type: 'object',
    properties: {
        presetCategories: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    img: {
                        type: 'string'
                    },
                    imgAlt: {
                        type: 'string'
                    },
                    presets: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                configurationId: {
                                    type: 'string'
                                },
                                revisionId: {
                                    type: 'string'
                                },
                                readToken: {
                                    type: 'string'
                                },
                                name: {
                                    type: 'string'
                                },
                                description: {
                                    type: 'string'
                                },
                                img: {
                                    type: 'string'
                                },
                                imgAlt: {
                                    type: 'string'
                                },
                                detailTitle: {
                                    type: 'string'
                                },
                                detailDescription: {
                                    type: 'string'
                                },
                                tags: {
                                    type: 'array',
                                    items: {
                                        type: 'string'
                                    }
                                }
                            },
                            required: [
                                'configurationId',
                                'revisionId',
                                'readToken',
                                'name',
                                'description'
                            ],
                            additionalProperties: false
                        }
                    }
                },
                required: [
                    'id',
                    'name',
                    'presets'
                ],
                additionalProperties: false
            }
        },
        recipes: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    collection: {
                        type: 'string'
                    },
                    configuration: {
                        type: 'object',
                        properties: {
                            modelVersion: {
                                type: 'number'
                            },
                            entities: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    properties: {
                                        id: {
                                            type: 'string'
                                        },
                                        type: {
                                            type: 'string'
                                        }
                                    },
                                    required: [
                                        'id',
                                        'type'
                                    ],
                                    additionalProperties: true
                                }
                            },
                            rootEntityType: {
                                type: 'string'
                            },
                            recipeIds: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            }
                        },
                        required: [
                            'modelVersion',
                            'entities',
                            'rootEntityType',
                            'recipeIds'
                        ],
                        additionalProperties: false
                    }
                },
                required: [
                    'id',
                    'name',
                    'description',
                    'collection',
                    'configuration'
                ],
                additionalProperties: false
            }
        }
    },
    additionalProperties: false,
    required: []
};
export const SessionData = {};
export const FrontendData = {};
export const FinalizeData = {
    type: 'object',
    properties: {
        session: {
            type: 'string'
        },
        addToCartUrl: {
            type: 'string'
        }
    },
    required: [
        'session',
        'addToCartUrl'
    ],
    additionalProperties: false
};
export const PrefetchedFinalizeData = {};
export const FinalizeResult = {};
export const CallbackData = {};
export const BackendData = undefined;
export const NavigationState = new EnumReflection('NavigationState', {
    enum: [
        'Default'
    ]
});
export const ViewState = new EnumReflection('ViewState', {
    enum: [
        'Default'
    ]
});
export const ToolState = new EnumReflection('ToolState', {
    enum: [
        'Default'
    ]
});
export const AdminNavigationState = new EnumReflection('AdminNavigationState', {
    enum: [
        'Default'
    ]
});
export const AdminViewState = new EnumReflection('AdminViewState', {
    enum: [
        'Default'
    ]
});

//# sourceMappingURL=application-types.js.map